module.exports = __webpack_public_path__ + "img/stock6.bc51fddd.png";